import { Component, OnInit } from "@angular/core";
import { DataService_VppOperatorLookup } from "./shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-vpp-operator-lookup",
	templateUrl: "./vpp-operator-lookup.component.html",
	styleUrls: ["./vpp-operator-lookup.component.css"],
})
export class VppOperatorLookupComponent implements OnInit {
	constructor(private vppService: DataService_VppOperatorLookup) {}

	ngOnInit(): void {
		this.onManualLookup();
	}

	/////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////

	State: string = "PA";
	LicenseNbr: string = "";
	FirstName: string = "Jeffrey";
	LastName: string = "Carr";
	DOB: Date = new Date();
	IssueDate: Date = new Date();
	ExpireDate: Date = new Date();

	loading: boolean = false;

	//
	// Offender Compare
	//
	TestImage: string =
		"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAB4AKADASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD0Asd1KGNN/iNKOlAkiQMacGNRrUg6UDHhjS7jTVpR1oAeGIp+81HSNMidWFAEu80/e3esDV/EtppNsZHIZ/4VHevO774k6lPMwt7hYYycBVUfzoHY9j3c07ea8Wj+ImrROcXjSYOPnUEV0mmfEC9u3SE21s8hIyVJXA/E0BY9F3Gje3aoLaUzW6SHb8wz8rZFTUCF3mjzD3pKaetADjITSbzTaKAAu1Cu29enWkNCn51+tAmZx+8acOlIQdxpwoGKKkHSm49KcKAFFOHWkGaXHrQBma5rCaTYvNt8yQfdXOOfevMb3xdezzMbiWYK38KngfSt/wAeXTSJ9nh5YtknPSue8O+HgCLu7GXJ+RCeFHr9aTdkaU4cz0Kdxp+r6uoCh/KIypJpkHgC/kbLMc+/SvTbSIcYXAHSta3VEHMYzWfOzsjQSWp4bd+DNWsfmWNn2jjHOazQ97pk8S3EbxtnPzDGfavolkjdslAPwrG1XSbHUYXgnhVgwxnHI9wapTIlh77EHgLXodQsRaRp8yDIx6DqT+NdlmvKPBNmfDfjubTJZSYZoT5DE43d8V6tVJ3OOSs7BRRRTEFITQaSgApF/wBYv1pCaF++PrQBUP3jRQfvGnDpQA4Uo60U4dKAFAzTZ2MdvIw6haeKjuRm1lH+yaAPPb1VuNXdn+bGMg9KvQx8cAAdqzZpB/bEkYzuLdq1Fngt0BlbDH0PFTPVWOrD6as17RMAfNWhs2jpWDa6tAXAEmO3Na32rOSG4xWdjsunsW8fLnpx61TlGWxVK516K2Vmbdhait/ENpdtwevqelHKyHNGTr9hI93FfQnEkBDAjqMda9AtLj7XZw3H/PRA1cZrEoRAYyMOp5rpfDkyz6FbFSCFBXj2rVbHBV+NmpRRRTMxD0pKKaetACUq/eH1pKF++PrQBVP3jSg0h+8acOlADgaeOlMFPHSgBwqO5GbWXnHyGpBWfral9McAkDODiga3PPsB9cu5UcOuAVIPrVO/uHi3oYnmZU3MA20fQHvV+yhWOaQM3JO0571fWyQ/fRTz6VF1c7FTdrI5zSp2lhEyw+SCTtUuSRgV39huOhfaZMeZ5e4jHftWLNaRrHvC7FHGPWty2DjScFhgEZGaJSTNoU2kcpdyOY8vGkjuC21jxgVmafrMc6sfsTxhG2MeCpP4dK7abTYb4l49hbuBxn/CoY9FhjJ/dFG/2+RTU1Yh05NmZcwNJpDDcW8tt6t7V03gxfK8NQgkAu7MBntms+a2igtXjU/fBBrNspLltVsIYSUhR1Cgd+eaUXcylR5nd9D0SkPWkpM1ZyC009aCaSgBDQv3x9aCaav+sH1oAgP3jSg00n5j70ooAkFOBpgOKcKAJBVe/UNYTg9NpNWBTZ1DW8qkZBQ/yp20A81fInc4531oWs5cDcKrSoTNIB3ORU1lEf4jjHINY2uz0qU1bUfqkp+SPICgd88tUQ1OdbYxmJi/TgZqW9ubVZdoy0gHBAzUMTuXBCKFJBJLiqULbjlW191FyxvLhT9oKYUDa+AcNWlJeb0yCckcGs+LUIEQxPGNpGD6H8aRfkGQSyEZFS4sqFaL0e42WQyXSoTkfxVr6HZo181xsAEaYUehP/1qxYw8dwz+vOa6zSIVisQwV1Mh3EOOaqMdDmqz3NDNJSZo3VZxi0hNNzSZoAUmkX74+tITikX74+tAEBPzGnA8VGfvGlBxQBKD608EetQhs9qUHmqQFgH3p61XDYp4emBxWpxCG/lQjG1z+RpEBFq44HGa1vE1rgLfRrnBCyD29awrWXz+M5XNQ1ZnRRmZlxYSyyK8lxIgbqExg+2auQ2Nr5J3EsQOf3fJ/Wr/ANkPXPGeKmitJnH3to9hU37nXZ20MqLRLMysInuDk7jl8KPwrStlaGBonbd8x2n1HpV6KyOQC+QKj1BBEFK4LDtSWrInaJDa2zXOpwwgYH3nYeldjn3/ADrA8POryXZUdCoBrcqzhk23qOJ4pMmm5ozQSLmjNM3e1JmgB2fekB+cc96YTikDfOPrQBCW+Y80ufeoyfmNGaqwkyQN70u/3qLd60m7gnsO9MZPvp3mBVLHhQOSegrifEPxB03Rt9vbMLy8HBRG+RD/ALTf0FefN4o1LxPrcFtqF0RaO2PIi+RD9R3/ABptNK5N7tJHqureKNMmsLq2tZxcysu393yoP+90P4VytlcSQlnUnGfmA/pTJolhjCBQABjA7D0pIPlHPRj+VYc92d8KSUbG/HqERUbXJbqQRyKkTVlAADgj61iOq7eR0PBqusAlk6jHXiruhrnWiOk/tdE5LjOemc1UlvmvZeAQB0rISMLJhF69TV5CsMe7+I0XSWhLpyk7s09N1OXTTMI4Fm3Y+XftPHvW1pniWw1JzCZDa3ina1rcMFfPt2YH1FcxZgmYu3GT0rlviHGsU2n3KcSMGTPfjBFTTlzSsya9NRjzHsxJHXIz60uT614bovj7WdJ2p532m3x/qp+cfRuor0DSviDo+rxrFNI1hcFlwsrfI3PQMOPzrVwaV7HFGcW7XOxpD1xWb5U81srQ3K8ljvSQsMH0NLJb3JSMedjam0kOeTXP7SXY6fZR/mLxPvQp+YfWqkMckbBpHJ+9kbiRz0qyn3lq4tyV2rGckk7J3KxznofyoyR1B/KiitGZXsczrnjrSNGV0WX7Vcr/AMsojwD7tXmWu+ONX1wGJ5/s9qf+WEPAP1PU0UVqkiJSdzmiaI5XgmSaNtrowZT70UVT2BbnpWl6xDrlosifLcKMSxZ5B9foa0ShIwFOfpRRXHJWdj2KL5oajdsjKQFJOeRVZS8Ur8MATxxRRSLtcsxGQj7mfepVheaTGxiB7UUUmFjWtbWdCMgt7EdK848fakt7ri2kLAx2a+Wcd3PJoorWgryOTGNqBzYJIxS7sDFFFdh5hqaV4g1LSnBsruWAj+FT8p+q9K9B0H4kpPJHBq8CxFsAXEQ+Ue7L2/CiiplFNXGmzv8AIZQV5UjII6EUqhtw4PX0oornZsj/2Q==";

	ResultIndex: number = 0;
	SelectedResult: any;
	lstResults: any = [];

	errorMessage: any = "";

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////

	onManualLookup() {
		this.errorMessage = "";

		var fDOB = moment(this.DOB).format("MMDDYYYY");
		var fID = moment(this.IssueDate).format("MMDDYYYY");
		var fED = moment(this.ExpireDate).format("MMDDYYYY");

		if (String(fDOB).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Date of Birth";
			return;
		}
		if (String(fID).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Issue Date";
			return;
		}
		if (String(fED).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Expire Date";
			return;
		}

		this.loading = true;

		var parms: any = {
			State: this.State,
			LicenseNbr: this.LicenseNbr,
			FirstName: this.FirstName,
			LastName: this.LastName,
			DOB: fDOB,
			IssueDate: fID,
			ExpireDate: fED,
		};

		var result = this.vppService.ManualLookup(parms);
		result.subscribe(
			(response) => {
				console.log(response);
				this.lstResults = response;
				this.ResultIndex = 0;
				this.SelectedResult = this.lstResults[this.ResultIndex];
				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	onBack() {
		if (this.ResultIndex > 0) {
			this.ResultIndex -= 1;
		}

		this.SelectedResult = this.lstResults[this.ResultIndex];
	}

	onNext() {
		if (this.ResultIndex < this.lstResults.length - 1) {
			this.ResultIndex += 1;
		}
		//Loop?
		else {
			this.ResultIndex = 0;
		}

		this.SelectedResult = this.lstResults[this.ResultIndex];
	}

	FormatDate(d: Date) {
		return moment(d).format("MM/DD/YYYY");
	}

	FormatOffenderInfoDate(s: string) {
		return s.replace("0000", ""); //Year Only formatting
	}

	/////////////////////////////////////////////////////////////
}
